import { request, getCoreApiUrl } from '@/utils/ajax';

export interface Terms {
    sellerTermsText: string;
    sellerPrivacyPolicyUrl: string;
    sellerPrivacyPolicyName: string;
    sellerTermsAcceptRequired: boolean;
    bygrTermsAcceptRequired: boolean;
}

export interface GetAcceptedTermsDto {
    profileId: number;
    projectId: number;
    residentialUnitId: number;
}

export interface AcceptedTermsDto {
    id: number;
    projectId: number;
    profileId: number;

    projectName: string;
    residentialUnitName: string;

    acceptDate: string;

    termsText: string;
    privacyPolicyUrl: string;
}

/**
 * @deprecated use the new getProjectTerms() function from src/services/projects.ts
 */
export function getTerms(profileId: number | null): Promise<Terms> {
    const coreApiUrl = getCoreApiUrl();
    return request(`v1/terms`, { query: { profileId } }, coreApiUrl).then((x) => x.json());
}

export function acceptTerms(profileId: number | null) {
    const coreApiUrl = getCoreApiUrl();
    return request(
        `v1/terms/accept`,
        {
            json: true,
            body: {
                profileId,
            },
            method: 'PUT',
        },
        coreApiUrl
    );
}

export async function getAcceptedTerms(requestData: GetAcceptedTermsDto[]): Promise<AcceptedTermsDto[]> {
    const response = await request(
        `v1/terms/acceptances`,
        {
            method: 'POST',
            json: true,
            body: requestData,
        },
        getCoreApiUrl()
    ).then((response) => response.json());

    return response;
}
